import { render, staticRenderFns } from "./TeacherManager.vue?vue&type=template&id=616b0802&scoped=true&"
import script from "./TeacherManager.vue?vue&type=script&lang=ts&"
export * from "./TeacherManager.vue?vue&type=script&lang=ts&"
import style0 from "./TeacherManager.vue?vue&type=style&index=0&id=616b0802&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b0802",
  null
  
)

export default component.exports